module.exports = __webpack_public_path__ + "static/img/qq-group1.d6e97a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qq-group1.jpg
// module id = NrCO
// module chunks = 1